import { ExamplesPageLayout } from "../../pagelayouts/examples";
import { LANDING_PAGES_DOMAINS_SEO } from "../../pagelayouts/homepage";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>The best portfolio solution for every profession</>}
        description={
            <>
                Explore how Authory helps writers, journalists, and creators from every field build a self-updating professional portfolio. Browse use
                cases tailored to your role, from freelance writing to academic research and more.
            </>
        }
        categoriesLinks={[]}
        panelLinks={LANDING_PAGES_DOMAINS_SEO}
        masonryItems={{ users: [] }}
        ogTitle={"Portfolio Use Cases by Profession | Authory"}
        ogDescription={
            "Discover the best portfolio solution for your profession. From freelancers to academics, see how Authory helps you showcase and protect your work, automatically."
        }
        embedConf={[]}
        canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.USE_CASES}`}
        faq={[]}
    />
);

export default ExampleJobPage;
